import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { environment } from '@/app/environments/environment';
import { OrganizationService } from '@/app/services/organization/organization.service';
import {
  DomSanitizer,
  SafeResourceUrl,
} from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { BriefSectionComponent } from '../../../project-expression-of-interest/brief-section/brief-section.component';
import { MatDialog } from '@angular/material/dialog';
import { PreQualificationQuestionnaireViewComponent } from '../pre-qualification-questionnaire-view/pre-qualification-questionnaire-view.component';
import { PqqReadOnlyFormComponent } from '../pqq-read-only-form/pqq-read-only-form.component';
import { WrapperComponent } from '../../../../../wrapper/wrapper.component';
import { InternalApprovalComponent } from '@/app/components/global/internal-approval/internal-approval.component';
import { UserService } from '@/app/services/user.service';
import { ApprovalResponseComponent } from '@/app/components/global/approval-response/approval-response.component';
import { CustomTooltipComponent } from "../../../../../../global/custom-tooltip/custom-tooltip.component";
import { ToolTipMessages } from '@/app/enums/toolTipMessages.enum';
import { WarningMessages } from '@/app/enums/warning-messages.enum';
export interface pqqInitialInfo{
  project_name:string;
  client:string;
  reference_number:string;
  issue_date:string;
  submission_deadline:string;
}
@Component({
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    BriefSectionComponent,
    PqqReadOnlyFormComponent,
    WrapperComponent,
    CustomTooltipComponent,
  ],
  selector: 'app-pqq-final-form',
  templateUrl: './pqq-final-form.component.html',
  styleUrls: ['./pqq-final-form.component.css'],
})
export class PqqFinalFormComponent implements OnInit {
  projectIdNew: string;
  submittedInitiation: any;
  projectId: any;
  enrichedOrganizations: any;
  isEdit = false;
  currentDialog = 'PQQ';
  pqqId: any;
  usersList: any;
  showTooltip: boolean = false;

  roles = [
    'Admin',
    'Project Manager',
    'Site Supervisor',
    'Civil Engineer',
    'Quantity Surveyor',
    'Architect',
    'Safety Officer',
    'Construction Manager',
    'Procurement Officer',
    'Foreman',
  ];
  orgInfo: any;
  checkApprove: boolean;
  internalApproval: any;
  initialData: pqqInitialInfo;
  approvalsStatus: string;
  toolTipMessage = ToolTipMessages;
  projectIdentifier: string;

  constructor(
    private toast: NgToastService,
    private TenderingService: TenderingService,
    private sanitizer: DomSanitizer,
    private OrganizationService: OrganizationService,
    private GetProjectIdService: GetProjectIdService,
    private projectsService: ProjectsService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private ActivatedRoute: ActivatedRoute
  ) {}
  // form: FormGroup;
  mapLink!: SafeResourceUrl;
  google_api_key = environment.apiKey;
  searchTerm = '';
  filteredOrganizations: any[] = [];
  resetRichTextEditor = false;
  eoiData: any;
  other = false;
  showTemplateForm:any;

  private subscription: Subscription = new Subscription();
  selectedWorkPackages: { id: number; name: string }[] = [];
  isCreator = false;
  approvalResponses: any;
  sendApprovals = false;
  isInApprovers = false;
  approvalNote: any;

  projectName: string;
  ngOnInit(): void {
    this.projectId = this.activatedRoute.snapshot.paramMap.get('projectId')!;
    this.pqqId = this.activatedRoute.snapshot.paramMap.get('pqqId')!;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.TenderingService.setpqqId(this.pqqId);
    this.preInitiationData();
    this.submittedInitiationData();

    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
      this.preInitiationData();
      this.submittedInitiationData();
    });

    const orgInfoString = localStorage.getItem('org_info');
    if (orgInfoString) {
      this.orgInfo = JSON.parse(orgInfoString); // Converts the string to an object
    }

    this.fetchUsers();
    this.getPqqApprovalsStatus();
  }
  organizationControl = new FormControl();
  company_name = new FormControl();
  name = new FormControl();
  position = new FormControl();
  email = new FormControl();
  organizations: any;
  selectedOrganizations: any[] = [];
  initiatedSelectedWorkPackages: [] = [];

  otherSelection() {
    this.other = true;
  }

  submittedInitiationData(): any {
    return this.projectsService.getSubmittedInitiationDataPQQ().subscribe({
      next: (response: any) => {
        this.submittedInitiation = response.data;
        this.initiatedSelectedWorkPackages =
          this.submittedInitiation?.selected_work_packages;
        this.initialData = {
          project_name: this.projectName,
          client: this.submittedInitiation?.client,
          reference_number: this.submittedInitiation?.reference_number,
          issue_date: this.submittedInitiation?.issue_date,
          submission_deadline: this.submittedInitiation?.submission_deadline,
        };
        const initiator_id = response?.data?.initiator_id;

        if (initiator_id === this.orgInfo?.pivot?.user_id) {
          this.isCreator = true;
        } else {
          this.isCreator = false;
        }
        this.enrichOrganizations();
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  enrichOrganizations(): void {
    // Combine `selected_organizations` with corresponding `responses`
    this.enrichedOrganizations =
      this.submittedInitiation?.selected_organizations.map(
        (org: any, index: number) => ({
          ...org,
          response: this.submittedInitiation?.responses[index] || {},
        })
      );
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  preInitiationData() {
    this.projectsService.getPreInitiationData().subscribe({
      next: (response: any) => {
        this.eoiData = response.data;
        if (this.eoiData) {
          // Convert latitude and longitude to numbers
          const latitude = parseFloat(this.eoiData.projectDetails.latitude);
          const longitude = parseFloat(this.eoiData.projectDetails.longitude);

          // Check if the conversion was successful
          if (!isNaN(latitude) && !isNaN(longitude)) {
            const url = `https://www.google.com/maps/embed/v1/place?key=${this.google_api_key}&q=${latitude},${longitude}&zoom=12`;
            this.mapLink = this.sanitizer?.bypassSecurityTrustResourceUrl(url);
          } else {
            this.mapLink = null;
          }
        }
      },
      error: (error: any) => {
        console.error('Failed to fetch EOI initiation data:', error);
      },
    });
  }

  async sendInvitations() {
    this.projectsService.initiatePQQ().subscribe({
      next: () => {
        this.handleClose();
        localStorage.removeItem('pqq_id');
        this.toast.success(
          'Pre Questionnaire qualification sent',
          'SUCCESS',
          4000
        );
      },
      error: (error: any) => {
        console.error('PQQ sent failed:', error);
        this.toast.danger(error.error.data, 'DANGER', 4000);
      },
    });
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
  handleClose() {
    this.router.navigate(['/pqq-submissions'], {
      queryParams: { projectName: this.projectName, projectIdentifier: this.projectIdentifier },
    });
  }

  handleEdit() {
    this.isEdit = !this.isEdit;
    this.TenderingService.setEditState(this.isEdit);
    this.TenderingService.setProjectIdentifier(this.projectIdentifier);
  }
  handleDialog() {
    this.isEdit = false;
    this.submittedInitiationData();
  }

  async openIndividualPQQResponsePreview(responseId) {
    const isPqqResponseSubmitted = await this.fetchPqqStatus(responseId);
    console.log('The response is:', isPqqResponseSubmitted);
    if (isPqqResponseSubmitted) {
      this.dialog.open(PreQualificationQuestionnaireViewComponent, {
        width: '70vw',
        height: '80vh',
        maxWidth: 'unset',
        autoFocus: false,
        data: {
          pqqId: this.pqqId,
          responseId: responseId,
          initialData: this.initialData,
          initiatedSelectedWorkPackages: this.initiatedSelectedWorkPackages,
        },
      });
    } else {
      this.toast.warning(
        WarningMessages.COMPANY_RESPONSE_MISSING_WARNING,
        'WARNING'
      );
    }
  }

  handleApprovals() {
    this.sendApprovals = true;
    const dialogRef = this.dialog.open(InternalApprovalComponent, {
      width: '80vw',
      height: 'auto',
      maxWidth: 'unset',
      autoFocus: false,
      data: {
        ResponseId: this.pqqId,
        projectId: this.projectId,
        users: this.usersList,
        approvalResponses: this.approvalResponses,
        modalType: 'pqq',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'closeApproval') {
        this.getPqqApprovalsStatus();
        this.sendApprovals = false;
      }
    });
  }

  fetchUsers() {
    this.userService.getUsers().subscribe(
      (response: any) => {
        if (response) {
          this.usersList = response.map((user: any) => ({
            id: user.id,
            name: user.name,
            role: this.roles[Math.floor(Math.random() * this.roles.length)],
            email: user.email,
          }));
        } else {
          console.error("Response does not contain 'data' property.");
        }
      },
      (error) => {
        console.log('Failed to load users: ', error);
      }
    );
  }

  async getPqqApprovalsStatus(): Promise<void> {
    try {
      const response = await this.projectsService
        .getApprovalsStatus(this.projectId, this.pqqId, 'pqq')
        .toPromise();

      this.internalApproval = response?.data;
      this.approvalNote = response?.data?.internal_approvals?.notes;

      if (response?.data) {
        this.approvalsStatus = response?.data?.internal_approvals?.status
          ? response?.data?.internal_approvals?.status
          : 'pending';

        let responses =
          response?.data?.internal_approvals?.internal_approval_responses;
        if (responses) {
          responses = responses.map((user: any) => ({
            id: user.user_id,
            role: this.roles[Math.floor(Math.random() * this.roles.length)],
            status: user?.status,
            comment: user?.comment,
            name: user?.name,
            email: user?.user?.email,
          }));
        }

        const userId = +this.orgInfo?.pivot?.user_id;

        const inApprovers =
          response?.data?.internal_approvals?.internal_approval_responses.find(
            (response: any) => response?.user_id === userId
          );

        if (inApprovers) {
          this.isInApprovers = true;
        } else {
          this.isInApprovers = false;
        }

        this.approvalResponses = responses;
        if (responses && this.orgInfo?.pivot?.user_id) {
          const matchingResponse = responses.find(
            (response: any) =>
              response?.id === userId && response?.status !== 'pending'
          );
          this.checkApprove = !!matchingResponse;

          if (this.checkApprove) {
            this.approvalResponses = null;
            this.approvalResponses = matchingResponse;
          }
        } else {
          this.checkApprove = false;
        }
      }
    } catch (error) {
      console.error('Error approvals status:', error);
    }
  }

  approvalResponseView(ResponseId: any, projectId: any) {
    this.sendApprovals = true;
    const dialogRef = this.dialog.open(ApprovalResponseComponent, {
      width: '70vw',
      maxHeight:'80vh',
      maxWidth: 'unset',
      autoFocus: false,
      data: {
        ResponseId: ResponseId,
        projectId: projectId,
        note: this.approvalNote,
        modalType: 'pqq',
        approvalSender: this.approvalResponses,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'closeApproval') {
        this.sendApprovals = false;
        this.getPqqApprovalsStatus();
      }
    });
  }

  tooltipVisibilityToggle() {
    this.showTooltip = !this.showTooltip;
  }
  fetchPqqStatus(pqqResponseId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.TenderingService.checkPqqResponseStatus(
        this.projectId,
        this.pqqId,
        pqqResponseId
      ).subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            resolve(response?.data);
          } else {
            reject('Failed to fetch response');
          }
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
}
